__webpack_require__.p = "/vahak_nextjs/_next/";